import React, {useCallback} from 'react';


const DropdownContainer = props => {
  // console.log(props, 'props')

  // const measureDomElement = useCallback(node => {
  //    if (node) props.updateHeights(props.index, parseInt(props.origHeight), node.clientHeight);
  // }, [])

  const measureDomElement = useCallback(node => {
     if (node && parseInt(props.height) !== node.clientHeight) {
       // console.log(parseInt(props.height), node.clientHeight)
       props.updateHeights(props.index, parseInt(props.origHeight), node.clientHeight);
     }
  })

  return(
    <React.Fragment>
      {React.Children.map(props.children, child => {
        return React.cloneElement(child, {measureCallback: measureDomElement});
      })}
    </React.Fragment>
  )
}

export default DropdownContainer;
